import React, {useCallback, useEffect, useRef, useState} from "react";
import { useHistory } from "react-router-dom";
import Input from "../components/inputItem";
import useForm from "rc-form-hooks";
import {getSystemsCaptchaJpg, getSystemsCaptchaSms, SystemsLoginSms, getAgreements} from "../service";
import {getUuid, flatObj, saveUserStorage, UserStorage} from "../units";
import bg from '../images/bg.jpg';
import CountriesPicker from "../components/countries";
import {useLoading} from "../components/loading/LoadingProvider";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../store/actions";


function LoginPage() {
    const [uuid, setUuid] = useState<string>(getUuid());
    const [captcha, setCaptcha] = useState<boolean>(false);
    const [captchaImage, setCaptchaImage] = useState<string>('');
    const [step, setStep] = useState<number>(179)
    const his = useHistory()
    const codeRef = useRef("86")
    const [cover,setCover] = useState<boolean>(false)
    const loading = useLoading()
    const dispatch = useDispatch()
    const [xy,setXy] = useState(true)
    const [agree,setAgree] = useState<string>()
    // const [mobile, setMobile] = useState<string>('')


    const {getFieldDecorator, validateFields, setFieldsValue, values} = useForm<{
        phone: string,
        captcha: string,
        email: string,
        captchaJpg: string,
        password: string
    }>();

    useEffect(() => {
        getAgreements().then(res => {
            if(res.code === 1){
                setAgree(res.data.agreementDetail)
            }
        })
    },[])

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {

                if(!xy){
                    loading.showError('请勾选《用户注册协议》')
                    return;
                }

                loading.showLoading('正在登陆')
                SystemsLoginSms({
                    captcha: res.captcha,
                    mobile: res.phone,
                    areaCode: codeRef.current
                }).then(data => {
                    if (data.code === 1) {
                        const userData = flatObj<UserStorage>(data.data)
                        dispatch(userInfoAction(userData))
                        loading.showSuccess('登陆成功',() => {
                            if(his.length < 2){
                                his.replace('/user')
                            }else{
                                his.goBack()
                            }
                        })
                    } else {
                        loading.showError(data.msg)
                        if(data.msg.search('已过期') !== -1){
                            setUuid(getUuid())
                        }
                    }
                })
            })
            .catch(e => {
                loading.showError('登陆失败')
            });
    }, [values])

    useEffect(() => {
        // 60s倒计时
        if (captcha) {
            const id = setInterval(() => {
                setStep(c => {
                    if (c - 1 === 0) {
                        clearInterval(id)
                        setCaptcha(false)
                        return 179
                    }
                    return c - 1
                })
            }, 1000)
            return () => clearInterval(id)
        }
    }, [captcha])

    const captchaHandle = () => {
        // console.log(values)

        if (values.captchaJpg && values.phone && !captcha) {
            loading.showLoading()
            // 发送手机验证码
            getSystemsCaptchaSms({
                uuid,
                captcha: values.captchaJpg,
                mobile:  values.phone,
                areaCode: codeRef.current
            }).then(res => {
                if (res.code === 1) {
                    setCaptcha(true)
                    loading.showSuccess('发送成功',function (){},1000)
                } else {
                    loading.showError(res.msg)
                    setUuid(getUuid())
                }
            })
        }
    }


    useEffect(() => {
        // 监听uuid变化 ，更新图片验证码
        // console.log(uuid)
        getSystemsCaptchaJpg({
            uuid
        }).then(res => {
            if (res.code === 1) {
                setCaptchaImage(res.data)
                setFieldsValue({'captchaJpg':'','captcha':''})
                setCaptcha(false)
            } else {
                loading.showError(res.msg)
            }
        })
    }, [uuid])

    const captchaImageHandle = () => {
        // 判断是否发送验证码，已发送 停止更新 uuid
        if (!captcha) {
            setUuid(getUuid())
        }
    }


    return <div className="login">
        <div className="img-box" style={{ backgroundImage:`url(${ bg })` }}/>
        <div className="login-box">
            <div className="section">
                <form onSubmit={handleSubmit}>

                    <div className="flex">
                        <div className="common-input-box">
                            <CountriesPicker label={"+"} onChange={ (code) => codeRef.current = code.areaCode }/>
                        </div>

                        {
                            getFieldDecorator('phone', {
                                rules: [{required: true, message: '请输入手机号'}]
                            })(<Input type={'number'} placeholder='请输入手机号'
                                      extraClass={['no-border-top', 'fill-width']}
                                      clear/>)
                        }
                    </div>

                    {
                        getFieldDecorator('captchaJpg', {
                            rules: [{required: true, message: '请输入识别码'}],
                        })(<Input label='识别码' type={'text'} placeholder='请输入识别码' icon="&#xe61e;">
                            <div className="captchaImage" onClick={captchaImageHandle}>
                                <img src={captchaImage} alt=""/>
                            </div>
                        </Input>)
                    }

                    {
                        getFieldDecorator('captcha', {
                            rules: [{required: true, message: '请输入短信验证码'}]
                        })(<Input label='验证码' type={'text'} placeholder='请输入验证码' icon="&#xe622;">
                            <div className="captcha" onClick={captchaHandle}>
                                {
                                    captcha ? <p>{step}s重新发送</p> : <p>发送验证码</p>
                                }

                            </div>
                        </Input>)
                    }

                    <div className="rStar">

                        <p onClick={() => setXy(x => !x)}>
                            <i className={ xy ?'active' : '' }/>
                            勾选表示您同意 <span onClick={(event)=> {
                                event.stopPropagation()
                                setCover(true)
                        }}>《用户注册协议》</span>
                        </p>

                    </div>

                    <button type={'submit'} className="common-btn submit">登录</button>
                </form>

            </div>
            {/*{*/}
            {/*    active === 1 && <div className="section">*/}
            {/*        <form onSubmit={handleSubmit}>*/}
            {/*            {*/}
            {/*                getFieldDecorator('email', {*/}
            {/*                    rules: [{required: true, message: '请输入账号'}]*/}
            {/*                })(<Input label='账&nbsp;&nbsp;号' placeholder='请输入账号'*/}
            {/*                          extraClass={['no-border-top', 'fill-width']} clear/>)*/}
            {/*            }*/}
            {/*            {*/}
            {/*                getFieldDecorator('password', {*/}
            {/*                    rules: [{required: true, message: '请输入密码'}]*/}
            {/*                })(<Input label='密&nbsp;&nbsp;码' placeholder='请输入密码' type={'password'}*/}
            {/*                          extraClass={['no-border-top', 'fill-width']}*/}
            {/*                          clear/>)*/}
            {/*            }*/}
            {/*            <button className="common-btn submit">登录</button>*/}
            {/*        </form>*/}
            {/*    </div>*/}
            {/*}*/}

            {/*<div className="tip">*/}
            {/*    <Link to={'/login/register'}>国外用户收不到短信？试试邮箱登录注册 <span style={{fontSize: '12px'}}*/}
            {/*                                                          className='iconfont'>&#xe608;</span> </Link>*/}
            {/*</div>*/}

        </div>

        {
            cover && <div className="coverXY">
                <div className="box">
                    <h2 className="header">用户注册协议</h2>
                    <div className="content">
                        <div dangerouslySetInnerHTML={{ __html:agree ? agree : ''}}/>
                    </div>
                    <div className="btns">
                        <div className="btn" onClick={() => setCover(false)}>我已阅读</div>
                    </div>
                </div>
            </div>
        }
    </div>
}

export default LoginPage;
